import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/pages/HomePage_Quality'
import Cart from '@/pages/Cart'

import GoodsList from '@/pages/goods/GoodsList'
import Detection from '@/pages/goods/Detection'
import SampleManage from '@/pages/sample/sample-manage'
import SampleResult from '@/pages/sample/sample-result'
// import Search from '@/pages/goods/Search'

import Address from '@/pages/order/Address'
import OrderConfirm from '@/pages/order/OrderConfirm'
import OrderConfirmbk from '@/pages/order/OrderConfirmbk'
import OrderSuccess from '@/pages/order/OrderSuccess'

import Company from '@/pages/company/Company'
import ComIndex from '@/pages/company/ComIndex'
import ComAllGoods from '@/pages/company/ComAllGoods'

import Mine from '@/pages/user/Mine'
import OrderList from '@/pages/user/OrderList'
import OrderDesc from '@/pages/user/OrderDesc'
import CustomerList from '@/pages/user/CustomerList'
import Setting from '@/pages/user/Setting'
import OrderLogistics from '@/pages/user/OrderLogistics'
import MyAddress from '@/pages/user/MyAddress'
import MyCoupons from '@/pages/user/MyCoupons'
import MyReport from '@/pages/user/MyReport'
import MyMedicalReport from '@/pages/user/MyMedicalReport'
import Inspection from '@/pages/Inspection'
import Medicines from '@/pages/Medicines'
import Medicine from '@/pages/medicines/medicine'
import QualityApply from '@/pages/QualityApply'
import ApplyForm from '@/pages/ApplyForm'
import ApplyFormPro from '@/pages/ApplyForm_pro'
import Vendor from '@/pages/Vendor'
import HomePage2 from '@/pages/HomePage2'

import promotion from '@/pages/promotion'

import UserList from '@/pages/user/UserList'

import AboutUs from '@/pages/AboutUs'

/*优惠券*/
import CouponsCenter from '@/pages/couponsCenter'

/*新冠自采样*/
import NovelCoronavirusSample from '@/pages/activities/novel-coronavirus-sample'
import NovelCoronavirusApply from '@/pages/activities/novel-coronavirus-apply'
import NovelCoronavirusApply2 from '@/pages/activities/novel-coronavirus-apply2'
import NovelCoronavirusUpload from '@/pages/activities/novel-coronavirus-upload'

import NovelCoronavirusCustoms from '@/pages/activities/novel-coronavirus-customs'
import NovelCoronavirusEnter from '@/pages/activities/novel-coronavirus-enter'
import NovelCoronavirusEnterApply from '@/pages/activities/novel-coronavirus-enter-apply'

/*预约*/
import Address2 from '@/pages/appoint/Address'
import Address3 from '@/pages/appoint/Address3'
import Address4 from '@/pages/appoint/Address4'
import OrderConfirm2 from '@/pages/appoint/OrderConfirm'
import OrderSuccess2 from '@/pages/appoint/OrderSuccess'

/*退换货*/
import ApplyRefund from '@/pages/user/ApplyRefund'
import MyRefund from '@/pages/user/MyRefund'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },

    {
      path: '/company',
      name: 'Company',
      component: Company,
      children: [
        {
          path: "index",
          name: "ComIndex",
          component: ComIndex
        },
        {
          path: "all",
          name: "ComAllGoods",
          component: ComAllGoods
        }
      ]
    },

    {
      path: '/goodsList',
      name: 'GoodsList',
      component: GoodsList
    },
    {
      path: '/detection',
      name: 'Detection',
      component: Detection
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/address',
      name: 'Address',
      component: Address,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/orderConfirm',
      name: 'OrderConfirm',
      component: OrderConfirm,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/orderConfirmbk',
      name: 'OrderConfirmbk',
      component: OrderConfirmbk,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/orderSuccess',
      name: 'OrderSuccess',
      component: OrderSuccess
    },
    {
      path: '/mine',
      name: 'Mine',
      component: Mine,
      meta: {
        requireAuth: true,
      },
      children: [
        {
          path: 'orderList',
          name: 'OrderList',
          component: OrderList
        },
        {
          path: 'orderDesc',
          name: 'OrderDesc',
          component: OrderDesc
        },
        {
          path: 'customerList',
          name: 'CustomerList',
          component: CustomerList
        },
        {
          path: 'setting',
          name: 'Setting',
          component: Setting
        },
        {
          path: 'orderLogistics',
          name: 'OrderLogistics',
          component: OrderLogistics
        },
        {
          path: 'myAddress',
          name: 'MyAddress',
          component: MyAddress
        },
        {
          path: 'myReport',
          name: 'MyReport',
          component: MyReport
        },
        {
          path: 'myMediaclReport',
          name: 'MyMedicalReport',
          component: MyMedicalReport
        },
        {
          path: 'myRefund',
          name: 'MyRefund',
          component: MyRefund
        },
        {
          path: 'applyRefund',
          name: 'ApplyRefund',
          component: ApplyRefund
        },
        {
          path: 'sampleManage',
          name: 'SampleManage',
          component: SampleManage
        },
        {
          path: 'sampleResult',
          name: 'SampleResult',
          component: SampleResult
        },
        {
          path: 'userList',
          name: 'UserList',
          component: UserList
        },
        {
          path: 'myCoupons',
          name: 'MyCoupons',
          component: MyCoupons
        }
      ]
    },
    {
      path: '/inspection',
      name: 'inspection',
      component: Inspection
    },
    {
        path: '/medicines',
        name: 'Medicines',
        component: Medicines,
    },
    {
      path: '/qualityApply',
      name: 'qualityApply',
      component: QualityApply,
    },
    {
      path: '/ApplyForm',
      name: 'ApplyForm',
      component: ApplyForm,
    },
    {
      path: '/ApplyForm_pro',
      name: 'ApplyForm_pro',
      component: ApplyFormPro,
    },
    {
        path: '/med',
        name: 'medicine',
        component: Medicine
    },
    {
      path: '/homepage2',
      name: 'homepage2',
      component: HomePage2
    },
    {
      path: '/vendor',
      name: 'vendor',
      component: Vendor
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: promotion
    },
    {
      path: '/NovelCoronavirusSample',
      name: 'NovelCoronavirusSample',
      component: NovelCoronavirusSample
    },
    {
      path: '/NovelCoronavirusApply',
      name: 'NovelCoronavirusApply',
      component: NovelCoronavirusApply
    },
    {
      path: '/NovelCoronavirusApply2',
      name: 'NovelCoronavirusApply2',
      component: NovelCoronavirusApply2
    },
    {
      path: '/NovelCoronavirusUpload',
      name: 'NovelCoronavirusUpload',
      component: NovelCoronavirusUpload
    },
    {
      path: '/NovelCoronavirusCustoms',
      name: 'NovelCoronavirusCustoms',
      component: NovelCoronavirusCustoms
    },
    {
      path: '/NovelCoronavirusEnter',
      name: 'NovelCoronavirusEnter',
      component: NovelCoronavirusEnter
    },
    {
      path: '/NovelCoronavirusEnterApply',
      name: 'NovelCoronavirusEnterApply',
      component: NovelCoronavirusEnterApply
    },
    {
      path: '/Address2',
      name: 'Address2',
      component: Address2,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/Address3',
      name: 'Address3',
      component: Address3,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/Address4',
      name: 'Address4',
      component: Address4,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/OrderConfirm2',
      name: 'OrderConfirm2',
      component: OrderConfirm2
    },
    {
      path: '/OrderSuccess2',
      name: 'OrderSuccess2',
      component: OrderSuccess2
    },
    {
      path: '/about',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/couponsCenter',
      name: 'CouponsCenter',
      component: CouponsCenter
    }
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js